import { formatDate,formatDatetime } from '../utils/datetime';

export function convertJsonData(original, originalColumns) {
    return original.map((o, index) => {
        const n = {};
        n['key'] = index;
        originalColumns.forEach((col, i) => {
            if (!col.children) {
                if (col.title.indexOf('日期') != -1 && typeof o[col.title] == 'object') {
                    //o[col.title] = new Date(o[col.title]).toLocaleDateString();
                    o[col.title] = formatDate(new Date(o[col.title]));
                }
                if ((col.title.indexOf('工作單完成時間') != -1 || col.title.indexOf('拒絕時間') != -1 || col.title.indexOf('Created date and time') != -1) && typeof o[col.title] == 'object') {
                    //o[col.title] = new Date(o[col.title]).toLocaleString();
                    o[col.title] = formatDatetime(new Date(o[col.title]));
                }
                n[col.dataIndex] = o[col.title];
            } else {
                col.children.forEach(child => {
                    n[child.dataIndex] = o[child.title];
                });
            }
        });
        return n;
    });
}


/**
 * Convert array of objects with old keys to array of objects with new keys.
 */
export function convertArrayData(original, originalKeys, newKeys) {
    return original.map((o) => {
        const n = {};
        originalKeys.forEach((v, i) => {
            n[newKeys[i]] = o[v];
        });
        return n;
    });
}
